import { Component, Input, OnInit } from '@angular/core';
import { HelpersService } from 'src/app/shared/services/helpers.service';
import { NodeService } from 'src/app/shared/services/node.services';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { NavigationService } from 'src/app/shared/services/navigation.service';

@Component({
  selector: 'app-level-menu-expanded',
  templateUrl: './level-menu-expanded.component.html',
  styleUrls: ['./level-menu-expanded.component.scss'],
  animations: [
    trigger('sidenavTrigger', [
      state('void', style({
        opacity: 0
      })),
      state('*', style({
        opacity: 1
      })),
      transition('void <=> *', animate('250ms ease-in-out'))
    ])
  ]
})
export class LevelMenuExpandedComponent implements OnInit {

  @Input() levelMenu: any;
  public menuExpanded: boolean = false;
  public menuMobileExpanded: boolean = false;
  public path: string = this.helpersService.isBrowser ? decodeURIComponent(window.location.pathname) : "";
  public logo: any;

  constructor(
    private helpersService: HelpersService, 
    private nodeService: NodeService, 
    public navigationService: NavigationService
  ) { }

  ngOnInit(): void {
    this.setLogo();
    this.isOpenMenu();
  }

  private isOpenMenu(): void {
    this.helpersService.openLocalMenuBS.subscribe(value => {
      this.menuExpanded = value;
    });
  }

  public closeMenu(): void {
    this.menuExpanded = false;
  }

  public openMenuMobile(): void {
    this.menuMobileExpanded = true;
  }

  public closeMenuMobile(): void {
    this.menuMobileExpanded = false;
  }

  public expandMobileMenu() {
    this.menuMobileExpanded = !this.menuMobileExpanded;
    this.helpersService.scrollOnTopBS.next(this.menuMobileExpanded);
  }

  private setLogo(): void {
    this.logo = {
      url: this.nodeService.header.field_logo_universita[0].url,
      alt: this.nodeService.header.field_logo_universita[0].alt
    }
  }

  public getDecodeURIComponent(text: string) {
    return decodeURIComponent(text);
  }

}
